/* eslint-disable eqeqeq */
import React, { FC, useState } from "react";
import { EmailModule } from "../type";
import style from "./style.module.scss";
import { useAuth } from "../../../store/context/login";

const PHONE_MAX = 10;
// RFC 5321 caps an address at 254 characters. The field used to stop at 50,
// which silently clipped long-but-valid work addresses.
const EMAIL_MAX = 254;

// Number("") is 0, so a bare isNaN("") returns FALSE and an empty field reads as
// "this is a phone number". Every phone-vs-email decision goes through here so
// that trap can't come back.
const isPhoneLike = (value: any) => value !== "" && !isNaN(value);

// Neither an email nor a phone number can contain whitespace, and copying an
// address out of a mail client or a web page routinely drags some along —
// frequently a non-breaking space, which looks identical and is why a pasted
// address can fail the lookup for no visible reason. \s covers those too.
const stripSpaces = (value: any) =>
  typeof value === "string" ? value.replace(/\s/g, "") : value;

const EmailInput: FC<EmailModule> = ({ onSubmit, userData }) => {
  // const [isEmailPhoneValid, setisEmailPhoneValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const { sendOtpEmail, sendOtpPhone } = useAuth();
  const [loginInput, setloginInput] = useState(userData.info);

  const handleChange = async () => {
    // Belt and braces: state can also be seeded from props, which never pass
    // through handleTextChange.
    const identifier = stripSpaces(loginInput);
    if (identifier !== loginInput) setloginInput(identifier);

    if (identifier == "") {
      setErrorMessage("Please enter a registered Phone number or email id");
      return;
    }
    if (!isPhoneLike(identifier)) {
      const res = await sendOtpEmail(identifier);
      if (res.data.status !== 1) setErrorMessage("Please enter a registered email adrress");
      else {
        onSubmit(res.data.data.id, identifier, true);
        setErrorMessage("");
      }
    } else {
      const res = await sendOtpPhone(identifier);
      if (res.data.status !== 1) setErrorMessage("Please enter a registered Phone number");
      else {
        onSubmit(res.data.data.id, identifier, true);
        setErrorMessage("");
      }
    }
  };
  const handleTextChange = (e: any) => {
    const next = stripSpaces(e.target.value);
    // Cap against what was just entered, not against what the field held a
    // moment ago. This limit used to live in the input's maxLength, computed
    // from the PREVIOUS value — so pasting an email into an empty field was
    // measured against the 10-digit phone limit and arrived truncated.
    setloginInput(next.slice(0, isPhoneLike(next) ? PHONE_MAX : EMAIL_MAX));
  };

  // window.addEventListener("keyup", (e) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault();
  //     handleChange();
  //   }
  // });

  return (
    <>
      <div className={style.main_title}>Welcome Back</div>
      <div className={style.sub_title}>Please enter your details</div>
      <div className={style.input_container}>
        {isPhoneLike(loginInput) && <div className={style.isd}>+91</div>}
        <input
          maxLength={EMAIL_MAX}
          autoFocus={true}
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              handleChange();
            }
          }}
          type="text"
          className={`${errorMessage !== "" ? style.error : ""} ${
            isPhoneLike(loginInput) ? style.isd_active : ""
          }  `}
          style={{
            padding: `${isPhoneLike(loginInput) ? `12px 40px` : `12px`} `,
          }}
          value={loginInput}
          onChange={(e) => handleTextChange(e)}
          placeholder="Enter your phone number / email"
        />
        <div className={style.status_msg}>{errorMessage}</div>
        <button
          className={`${style.submit_btn} ${userData !== "" ? style.active : ""}`}
          onClick={(e) => handleChange()}
        >
          Get OTP
        </button>
      </div>
    </>
  );
};

export default EmailInput;
